import CustomButton from "./CustomButton";
import styles from "./BlackButton.module.css";

const BlackButton = ({ className="", ...props}) => {
  return (
    <CustomButton className={`${styles.button} ${className}`} {...props}/>
  );
}

export default BlackButton;